import { Link } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { Skeleton } from '@/components/ui/skeleton'
import { useMyActivity } from '../hooks/useMyActivity'
import { ActivityItemCard } from './ActivityItem'

export function ActivityFeed() {
  const { items, loading, errors } = useMyActivity()

  if (loading) {
    return (
      <div className="space-y-3">
        {[0, 1, 2].map((i) => (
          <Skeleton key={i} className="h-24 w-full rounded-xl" />
        ))}
      </div>
    )
  }

  const errorLines = [
    errors.engagements && `Services: ${errors.engagements}`,
    errors.tickets && `Tickets: ${errors.tickets}`,
    errors.orders && `Shop: ${errors.orders}`,
  ].filter(Boolean) as string[]

  if (items.length === 0 && errorLines.length === 0) {
    return (
      <div className="rounded-xl border border-dashed py-16 text-center space-y-4">
        <p className="text-sm text-muted-foreground">No activity yet.</p>
        <div className="flex justify-center gap-2">
          <Button asChild variant="outline" size="sm"><Link to="/events">Browse events</Link></Button>
          <Button asChild variant="outline" size="sm"><Link to="/shop">Visit the shop</Link></Button>
          <Button asChild variant="outline" size="sm"><Link to="/services">Book a service</Link></Button>
        </div>
      </div>
    )
  }

  return (
    <div className="space-y-4">
      {errorLines.map((line) => (
        <p key={line} className="text-sm text-destructive">{line}</p>
      ))}
      {items.map((item, idx) => (
        <ActivityItemCard key={`${item.kind}-${item.data.id}-${idx}`} item={item} />
      ))}
    </div>
  )
}
